import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MarketState } from 'store/modules/market_store/types';
import Pagination from 'components/atoms/pagination';
import BuyersModal from 'components/atoms/buyers_modal';
import { getPublicBody, searchBuyers } from 'store/modules/market_store/actions';
import Loader from 'components/atoms/loader';

interface BuyersProps {
  params: any;
  selectedFilter: number | object[];
}

const Buyers: React.FC<BuyersProps> = ({ params, selectedFilter }) => {
  const dispatch = useDispatch();
  const { orgao, request } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );
  const [BiddingInfoToggle, setBiddingInfoToggle] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [buyer, setBuyer] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const sortedOrgaos = orgao?.results?.slice().sort((a, b) => b.licitacao - a.licitacao);

  useEffect(() => {
    dispatch(searchBuyers(params, currentPage));
  }, [params, currentPage, selectedFilter]);

  const setBuyersInfo = (buyer_id: number) => {
    dispatch(getPublicBody(buyer_id));
    setBuyer(buyer_id);
    setShowModal(true);
  };

  const paginate = (newPage: number) => {
    setCurrentPage(newPage);
  };

  return (
    <div className="card overflow-auto">
      <div className="pl-2 my-2 d-flex align-items-center">
        <i className="material-icons">business</i>
        <b className="pl-1 mt-2">Órgão Público</b>
      </div>
      <ul className="list-group list-group-flush table-responsive" style={{ maxHeight: '500px' }}>
        {request?.search_buyers?.loading ? (
          <Loader />
        ) : (
          <table className="table">
            <thead style={{ backgroundColor: '#EBECEF' }}>
              <tr>
                <th scope="col">Nome do Órgão</th>
                <th scope="col">Estado</th>
                <th scope="col">Licitações</th>
              </tr>
            </thead>
            <tbody>
              {sortedOrgaos?.map((orgao) => (
                <tr key={orgao?.orgao_id} onClick={() => setBuyersInfo(orgao?.orgao_id)}>
                  <td data-tip={orgao?.nome}>
                    {orgao?.nome?.length > 50 ? `${orgao?.nome?.substring(0, 50)}...` : orgao?.nome}
                  </td>
                  <td>{orgao?.uf}</td>
                  <td>{orgao?.doc_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </ul>
      <div className="border rounded-bottom border-top-0 d-print-none">
        <button
          type="button"
          key="btn-bidding-more-info"
          className="btn btn-sm btn-link m-0 w-100 mb-3"
          onClick={() => setBiddingInfoToggle(!BiddingInfoToggle)}
        >
          {BiddingInfoToggle ? 'Ver menos' : 'Ver mais'}
        </button>
        {BiddingInfoToggle && (
          <div className="row d-print-none">
            <div className="col-md-12 px-4 mb-1">
              <Pagination
                postsPerPage={10}
                totalPosts={orgao?.total}
                paginate={paginate}
                currentPage={currentPage}
                firstAndLastPage
              />
            </div>
          </div>
        )}
      </div>
      <BuyersModal
        showModal={showModal}
        setShowModal={setShowModal}
        orgao={buyer}
        params={params}
      />
    </div>
  );
};

export default Buyers;
